import { mapAssistResultDto, type AssistRequestDto, type AssistResult, type AssistResultDto } from '@/types';

import type { AssistService } from '../assistService';
import { httpRequestWithRefresh, type HttpClientConfig } from './httpApiClient';
import { unwrapResult } from './httpEnvelope';

/**
 * HTTP impl of :type:`AssistService`(docs/76 §3;R136)。
 * `X-Current-Group` / CSRF 由 httpRequest 層自動注入(`/api/projects/*` 不在 exempt)。
 */

const PATH = {
  assist: (pid: string, nid: string) =>
    `/api/projects/${encodeURIComponent(pid)}/nodes/${encodeURIComponent(nid)}/assist`,
} as const;

export function createHttpAssistService(config: HttpClientConfig): AssistService {
  return {
    async assist(pid: string, nid: string, req: AssistRequestDto): Promise<AssistResult> {
      const env = await httpRequestWithRefresh<AssistResultDto>(
        config,
        'POST',
        PATH.assist(pid, nid),
        req,
      );
      return mapAssistResultDto(unwrapResult(env, 'assist.assist'));
    },
  };
}
